import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';
import {ServiceSuccessResponseType} from './service-mappers/BaseMapper';
import {
  ArrayResponse,
  ClinicBaseParams
  // PaginationBaseParams
} from './service-mappers/CommonServiceMapper';
import {
  VaccineReturnParams,
  RunningLowVaccinesData,
  ReturnedVaccinesByPeriodParams,
  ReturnedVaccinesDataWithCounts,
  VaccineData,
  SystemVaccineItem
} from './service-mappers/VaccineServiceMapper';

const expiringSoonUrl = environment.apiEndPoints.expire.expiringSoon;
const expiredDetailsUrl = environment.apiEndPoints.expire.expiredDetails;
const totalVaccinesDetailsUrl =
  environment.apiEndPoints.expire.totalVaccinesDetailsUrl;
const runningLowUrl = environment.apiEndPoints.expire.runningLow;
const allVaccineDetailsUrl =
  environment.apiEndPoints.allVaccines.allVaccinesDetails;
const expiringVaccinesDetailsUrl = environment.apiEndPoints.expire.expiringSoon;
const returnVaccineUrl = environment.apiEndPoints.inventory.returnVaccine;
const returnVaccineDetailsUrl =
  environment.apiEndPoints.returnVac.getAllByPeriodWithCounts;

export const expiringSoonDetails = async (
  clinicId: string,
  dateParams: {
    fromDate: any;
    toDate: any;
    search: any;
    vaccineProgramId: any;
  }
): Promise<any> => {
  let fromDate;
  let toDate;
  let params = '';
  if (dateParams) {
    fromDate = dateParams.fromDate;
    toDate = dateParams.toDate;
    params = dateParams.search ? `&search_text=${dateParams.search}` : '';
  }
  if (dateParams) {
    params += dateParams.vaccineProgramId
      ? `&vaccine_program_id=${dateParams.vaccineProgramId}`
      : '';
  }
  const url = `/clinic/${clinicId}${expiringSoonUrl}?from_date=${fromDate}&to_date=${toDate}${params}`;
  return AxiosCall.get(url);
};

export const expiredDetails = async (
  clinicId: string | number,
  dateParams: {
    expireDate: any;
    search: any;
    vaccineProgramId: any;
  }
): Promise<any> => {
  let expireDate;
  let params = '';
  if (dateParams) {
    expireDate = dateParams.expireDate ? dateParams.expireDate : '';
    params = dateParams.search ? `&search_text=${dateParams.search}` : '';
  }
  if (dateParams) {
    params += dateParams.vaccineProgramId
      ? `&vaccine_program_id=${dateParams.vaccineProgramId}`
      : '';
  }

  const url = `/clinic/${clinicId}${expiredDetailsUrl}?expired_date=${expireDate}${params}`;
  return AxiosCall.get(url);
};

export const totalVaccinesDetails = async (
  clinicId: string | number
): Promise<any> => {
  const url = `/clinic/${clinicId}${totalVaccinesDetailsUrl}`;
  return AxiosCall.get(url);
};

export const getRunningLowDetails = async (
  params: ClinicBaseParams
): Promise<
  ServiceSuccessResponseType<ArrayResponse<RunningLowVaccinesData>>
> => {
  return AxiosCall.get(`/clinic/${params.clinicId}${runningLowUrl}`);
};

export const expiredVaccineDetails = async (
  clinicId: string | number,
  receivedId: string | number
): Promise<any> => {
  const url = `/clinic/${clinicId}${expiredDetailsUrl}/${receivedId}`;
  return AxiosCall.get(url);
};

export const allVaccineList = async (params: {
  limit: number;
  start: number;
  search?: string;
  vaccineProgramId?: number | string;
  clinicId: string | number;
}): Promise<
  ServiceSuccessResponseType<ArrayResponse<Partial<VaccineData>>>
> => {
  let param = params.search ? `&search_text=${params.search}` : '';
  param += params.vaccineProgramId
    ? `&vaccine_program_id=${params.vaccineProgramId}`
    : '';
  const url = `/clinic/${params.clinicId}${allVaccineDetailsUrl}?limit=${params.limit}&offset=${params.start}${param}`;
  return AxiosCall.get(url);
};

export const allVaccineDetails = async (
  clinicId: string | number,
  inventoryId: string | number
): Promise<ServiceSuccessResponseType<VaccineData>> => {
  const url = `/clinic/${clinicId}${allVaccineDetailsUrl}/${inventoryId}`;
  return AxiosCall.get(url);
};

export const expiringVaccineDetails = async (
  clinicId: string | number,
  receivedId: string | number
): Promise<any> => {
  const url = `/clinic/${clinicId}${expiringVaccinesDetailsUrl}/${receivedId}`;
  return AxiosCall.get(url);
};

export const returnVaccine = async (
  params: VaccineReturnParams
): Promise<any> => {
  return AxiosCall.post(
    `/clinic/${params.clinicId}${returnVaccineUrl}/${params.receiveId}`,
    params.payload
  );
};

export const getReturnedVaccinesByPeriodWithCounts = async (
  params: ReturnedVaccinesByPeriodParams
): Promise<ServiceSuccessResponseType<ReturnedVaccinesDataWithCounts>> => {
  const urlParams = `${
    params.startDate ? `&start_date=${params.startDate}` : ''
  }
    ${params.endDate ? `&end_date=${params.endDate}` : ''}
    ${params.searchText ? `&search_text=${params.searchText}` : ''}
    ${typeof params.limit === 'number' ? `&limit=${params.limit}` : ''}
    ${
      typeof params.offset === 'number' ? `&offset=${params.offset}` : ''
    }`.trim();
  return AxiosCall.get(
    `/clinic/${params.clinicId}${returnVaccineDetailsUrl}${urlParams}`
  );
};

// Service to get vaccine list on system
export const getSystemVaccineList = async (
  params: any
): Promise<ServiceSuccessResponseType<ArrayResponse<SystemVaccineItem>>> => {
  return AxiosCall.get(
    `${environment.apiEndPoints.allVaccines.systemVaccineList}`
  );
};

export const getVaccineInformationFile = ({
  vaccine_type
}: {
  vaccine_type: 'vis_shingrix' | 'vis_fluarix';
}): Promise<ServiceSuccessResponseType<any>> => {
  return AxiosCall.getFileData(
    `/guarantor/schedule-appointment/vaccine/${vaccine_type}/file`
  );
};
